<template>
  <div class="container" :class="!pathMixin_isMeeting ? 'boxWithBorder' : ''">
    <SmallItinerarySidebar
      v-if="bookTrip.currentlyBooking"
      :sol="solutionAll"
      :key="
        solutionAll.flight.key + solutionAll.hotel.key + solutionAll.car.key
      "
      class="bookingDropdown mr-5"
    />

    <div
      v-if="!pathMixin_isMeeting"
      class="is-flex is-justify-content-center is-align-content-center mb-5"
    >
      <b-icon icon="bed" size="" type="is-primary"> </b-icon>
      <h2 class="gant-text is-bold ml-1">Hotels</h2>
    </div>

    <!-- FLIGHT DETAILS HEADER -->
    <FlightDetailsHeader />

    <!-- Meeting Info Bar bar -->
    <div v-if="pathMixin_isMeeting" class="box">
      <p class="is-size-5">
        Will you provide your own stay during this meeting?
      </p>
      <!-- <b-button>
          Opt out of flight search steps
        </b-button> -->
      <p class="is-size-6 mb-3">
        If you do not need a hotel booked for this meeting, please click below
        to skip the hotel search steps.
      </p>
      <b-button @click="optOutHotel" type="is-primary">
        No Hotel Required
      </b-button>
    </div>

    <div :class="pathMixin_isMeeting ? 'box' : ''">
      <div class="search-form-grid">
        <div class="location-search-container">
          <div class="location-input-group">
            <div class="search-location-field">
              <b-field
                :type="formErrors('place').length > 0 ? 'is-danger' : ''"
                :message="formErrors('place')[0]"
              >
                <b-input
                  v-if="!pathMixin_isMeeting"
                  v-model="place"
                  type="text"
                  placeholder="Where to?"
                  id="place"
                  icon="location-dot"
                  icon-pack="fas"
                  :loading="false"
                  @blur="blurred.push('place')"
                  expanded
                >
                </b-input>
                <b-field v-else>
                  <b-input
                    icon="location-dot"
                    icon-pack="fas"
                    :value="$store.state.hotelSearch.searchLocation.name"
                    disabled
                  ></b-input>
                </b-field>
              </b-field>
            </div>
            <div class="saved-addresses-select" v-if="!pathMixin_isMeeting && preferredLocations.length > 0">
              <div class="dropdown" :class="{ 'is-active': isDropdownOpen }">
                <div class="dropdown-trigger">
                  <button
                    class="button saved-address-button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    @click="toggleDropdown"
                    :disabled="isLoadingPreferredLocations && preferredLocations.length === 0"
                  >
                    <span class="icon is-small">
                      <i v-if="isLoadingPreferredLocations && preferredLocations.length === 0" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
                      <i v-else class="fas fa-bookmark" aria-hidden="true"></i>
                    </span>
                    <span>{{ isLoadingPreferredLocations && preferredLocations.length === 0 ? 'Loading...' : 'Saved Locations' }}</span>
                    <span v-if="!isLoadingPreferredLocations || preferredLocations.length > 0" class="icon is-small">
                      <i class="fas" :class="isDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu" v-if="!isLoadingPreferredLocations || preferredLocations.length > 0">
                  <div class="dropdown-content">
                    <div v-if="preferredLocations.length === 0 && !isLoadingPreferredLocations" class="dropdown-item">
                      <span class="has-text-grey">No saved addresses</span>
                    </div>
                    <a
                      v-for="(address, index) in preferredLocations"
                      :key="index"
                      class="dropdown-item"
                      @click="handleSavedAddressSelect(address)"
                    >
                      <div class="saved-address-option">
                        <span class="saved-address-name">{{ address.name }}</span>
                        <span class="saved-address-details">{{ address.address }}</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="search-dates-field">
          <b-field
            :type="formErrors('searchDates').length > 0 ? 'is-danger' : ''"
            :message="formErrors('searchDates')[0]"
          >
          <DateSelectorRange
            v-if="!pathMixin_isMeeting"
            segmentType="hotel"
            :minDate="new Date()"
            class="mr-1"
            v-model="searchDates"
            icon="calendar-alt"
            icon-pack="fas"
            trap-focus
            @blur="blurred.push('searchDates')"
          />
          <DatePickerSearchRangeMeetings
            v-if="pathMixin_isMeeting"
            v-model="searchDates"
            segmentType="hotel"
            :minDate="meetingInfo.meeting.earliestArrival.date"
            :maxDate="meetingInfo.meeting.latestDeparture.date"
          />
          </b-field>
        </div>

        <div class="search-button-container">
          <b-button
            type="is-primary"
            icon-pack="fas"
            icon-left="search"
            @click="submitForm"
            expanded
          >
            Search
          </b-button>
        </div>
      </div>

      <b-collapse
        :open="false"
        @open="toggleAdvancedSearch(true)"
        @close="toggleAdvancedSearch(false)"
        aria-id="contentIdForA11y1"
        class="mt-3"
        style="max-width:fit-content"
      >
        <a class="has-text-grey-light is-size-7" slot="trigger" >
          <b-icon icon="chevron-down" size="is-small" />
          Advanced Search Options
        </a>

        <div class="notification">
          <div class="content">
            <div class="field">
              <b-checkbox type="is-primary" v-model="active">
                Use Advanced Settings
              </b-checkbox>
            </div>

            <div class="columns mt-4">
              <div class="column">
                <b-field label="Radius Range by Miles">
                  <b-numberinput
                    v-model="radius"
                    min="0"
                    size="is-small"
                    controls-alignment="right"
                    controls-position="compact"
                  ></b-numberinput>
                </b-field>
              </div>

              <div class="column">
                <b-field label="Star Rating">
                  <b-select
                    v-model="starRating"
                    placeholder="Select Rating"
                    class="is-small"
                  >
                    <option
                      v-for="option in starRatings"
                      :value="option"
                      :key="option"
                    >
                      {{ option }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div class="column">
                <b-field label="Search by Hotel Chain">
                  <TagAutocomplete
                    placeholder="e.g. Hilton"
                    icon="magnify"
                    :chainData="chainData"
                    :selected="chains"
                    @list="
                      (options) => {
                        chains = options
                      }
                    "
                  >
                  </TagAutocomplete>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
const moment = require("moment")
import meetingsMixin from "../../../mixins/meetingsMixin"
import bookingMixin from "../../../mixins/bookingMixin"
import { mapState } from "vuex"
import DateSelectorRange from "@/components/DateComponents/DateSelectorRange.vue"
import DatePickerSearchRangeMeetings from "../../DateComponents/DatePickerSearchRangeMeetings"
import TagAutocomplete from "../../Tags/TagAutocomplete.vue"
import SmallItinerarySidebar from "../../Itinerary/SmallItinerarySidebar"
import FlightDetailsHeader from "@/components/BookTravel/FlightDetailsHeader.vue"

export default {
  mixins: [bookingMixin, meetingsMixin],
  components: {
    DateSelectorRange,
    DatePickerSearchRangeMeetings,
    TagAutocomplete,
    SmallItinerarySidebar,
    FlightDetailsHeader,
  },

  data() {
    return {
      googlePlace: null,
      place: "",
      submitted: false,
      blurred: [],
      isDropdownOpen: false,
      preferredLocations: [],
      isLoadingPreferredLocations: true,
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      dayNames: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      // advanced settings
      starRatings: ["5", "4", "3", "2", "1", "No Preference"],
      // validation rules
      rules: {
        place: [
          {
            message: "Search location is required",
            isValid() {
              return this.place && this.place.trim() !== ""
            },
          },
        ],
        searchDates: [
          {
            message: "Travel dates are required",
            isValid() {
              return this.searchDates?.filter((d) => d !== null).length > 1
            },
          },
          {
            message: "Please select future dates",
            isValid() {
              return (
                this.searchDates &&
                this.searchDates[1] > new Date() &&
                this.searchDates[1] > this.searchDates[0]
              )
            },
          },
        ],
      },
    }
  },

  computed: {
    ...mapState({
      profile: (state) => state.travellersAndTrips.currentTravellerProfile,
      advancedSearch: (state) => state.hotelSearch.advancedSearch,
      recentSearches: (state) => state.hotelSearch.recentSearches,
      searchErrors: (state) => state.hotelSearch.searchErrors,
      searchLocation: (state) => state.hotelSearch.searchLocation,
    }),

    chainData() {
      return Object.entries(this.$store.state.bookTravel.vendors.hotelChains)
    },

    active: {
      get() {
        return this.$store.state.hotelSearch.advancedSearch.active
      },
      set(value) {
        this.$store.commit("hotelSearch/SET_ADVANCED_ACTIVE", value)
      },
    },

    radius: {
      get() {
        return this.$store.state.hotelSearch.advancedSearch.radius
      },
      set(value) {
        this.$store.commit("hotelSearch/SET_RADIUS", value)
      },
    },

    starRating: {
      get() {
        return this.$store.state.hotelSearch.advancedSearch.starRating
      },
      set(value) {
        this.$store.commit("hotelSearch/SET_STAR_RATING", value)
      },
    },

    chains: {
      get() {
        return this.$store.state.hotelSearch.advancedSearch.chains
      },
      set(value) {
        this.$store.commit("hotelSearch/SET_ADVANCED_CHAINS", value)
      },
    },

    formValid() {
      return (
        this.rules.place[0].isValid.call(this) &&
        this.rules.searchDates[0].isValid.call(this) &&
        this.rules.searchDates[1].isValid.call(this)
      )
    },

    searchDates: {
      get() {
        if (
          this.$store.state.hotelSearch.searchDates[0] &&
          this.$store.state.hotelSearch.searchDates[1]
        ) {
          return Array(
            this.$store.state.hotelSearch.searchDates[0],
            this.$store.state.hotelSearch.searchDates[1]
          )
        } else {
          return []
        }
      },
      set(value) {
        this.$store.commit("hotelSearch/SET_SEARCH_DATES", value)
      },
    },

    isMeeting() {
      return this.pathMixin_isMeeting
    },
  },

  methods: {
    logSearchEvent() {

      // Log the event
      let eventData = {
        event_type: 'Search Submitted',
        event_properties: {
          item_type: 'hotel',
          // days_until_travel:
        }
      }
        
      this.$app.logEvent(eventData);
    },
    submitForm() {
      console.log("Form submitted")
      this.submitted = true
      if (this.formValid) {
        console.log("Form is ok")

        this.logSearchEvent()

        //this.$store.dispatch("hotelSearch/parseFormData")
        this.$store.dispatch("hotelSearch/getData", {
          cacheKey: null,
        })
      } else {
        console.log("Form is invalid")
      }
    },

    formErrors(field) {
      const errors = []
      if (this.rules[field].length > 0) {
        this.rules[field].forEach((r) => {
          if (!r.isValid.call(this)) {
            if (
              this.submitted === true ||
              (r.on === "blur" && this.blurred.includes(field))
            ) {
              errors.push(r.message)
            }
          }
        })
      }
      return errors
    },

    async initGooglePlaces() {
      const input = document.getElementById("place")
      const center = { lat: 34.082298, lng: -82.284777 }
      const defaultBounds = {
        north: center.lat + 0.1,
        south: center.lat - 0.1,
        east: center.lng + 0.1,
        west: center.lng - 0.1,
      }

      const options = {
        bounds: defaultBounds,
        types: [
          "airport",
          "locality",
          "tourist_attraction",
          "train_station",
          "lodging",
        ],
        fields: [
          "address_components",
          "geometry",
          "icon",
          "name",
          "formatted_address",
        ],
        strictBounds: false,
      }

      const Library = await this.$store.dispatch("hotelSearch/getPlacesLibrary")
      const autocomplete = new Library.Autocomplete(input, options)

      autocomplete.addListener("place_changed", () => {
        this.googlePlace = autocomplete.getPlace()
        console.log("Google Places object", this.googlePlace)

        //use the autocomplete result to set the searchLocation formData (name, lat, long)
        this.$store.dispatch(
          "hotelSearch/setLocationFromAutocomplete",
          this.googlePlace
        )
      })
    },

    toggleAdvancedSearch(boolean) {
      this.active = boolean
    },

    //Convert String date formated ("2025-05-22") into Date object w/o timezone
    convertDate(dateStr) {
      // Split the date string into parts
      const [year, month, day] = dateStr.split("-").map(Number);

      // Month is 0-based in JavaScript Date constructor, so subtract 1
      return new Date(year, month - 1, day);
    },

    setFormValues({ location = {}, dates = [] }) {
      console.log("Setting form values", location, dates)
      this.$store.commit("hotelSearch/SET_SEARCH_LOCATION", location)
      this.place = location.name
      this.$store.commit("hotelSearch/SET_SEARCH_DATES", [
        this.convertDate(dates[0]),
        this.convertDate(dates[1]),
      ])
    },

    //Use booked flight details to set default form values
    setFlightDefaults() {
      if (
        this.flightArrivalMoment.isValid() &&
        this.flightDepartureMoment.isValid()
      ) {
        this.checkoutDate = this.flightDepartureDate
        this.$store.commit("hotelSearch/SET_SEARCH_DATES", [
          this.flightArrivalDate,
          this.flightDepartureDate,
        ])
      }

      if (this.flightArrivalLeg?.arrivingAirport) {
        let code = this.flightArrivalLeg.arrivingAirport
        this.$store.dispatch("hotelSearch/setAirportLocation", code)
      }
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    handleSavedAddressSelect(address) {
      this.isDropdownOpen = false;
      if (address) {
        // First update the store with the location
        this.$store.dispatch("hotelSearch/setLocationFromAutocomplete", {
          name: address.name,
          geometry: {
            location: {
              lat: () => address.latitude,
              lng: () => address.longitude
            }
          }
        });
        // Then set the place value
        this.$nextTick(() => {
          this.place = address.name;
        });
      }
    },

    async getAccountDetails(accountId) {
      this.isLoadingPreferredLocations = true;

      const data = { accountId };
      const response = await this.$app.huddleLabsServerCall(
        "profile/account",
        data
      );
      const { savedLocations } = response.data;
      if (savedLocations) {
        this.preferredLocations = savedLocations;
      }

      this.isLoadingPreferredLocations = false;
    },
  },

  watch: {
    searchLocation(to, from) {
      if (to.name !== from.name) {
        this.place = to.name
      }
    },
  },

  mounted() {
    //preset form values in meeting mode
    if (this.pathMixin_isMeeting && this.meetingInfo) {
      let loc = {}
      let dates = [
        this.meetingInfo.meeting.earliestArrival.date,
        this.meetingInfo.meeting.latestDeparture.date,
      ]
      loc.name = this.meetingInfo.meeting.meetingLocation
      loc.latitude = this.meetingInfo.meeting.meetingLocationCoordinates?.latitude
      loc.longitude = this.meetingInfo.meeting.meetingLocationCoordinates?.longitude
      
      /*
      if (this.$route.query.key) {
        let savedSearch = this.recentSearches.find(
          (search) => search.key === this.$route.query.key
        )

        if (savedSearch) {
          //clone the saved search data
          let savedData = JSON.parse(JSON.stringify(savedSearch.formData))
          dates = [savedData.checkinDate, savedData.checkoutDate]
          console.log("Setting form values from cached search", dates)
        }
      } else if (this.flightArrivalMoment && this.flightDepartureMoment) {
        dates = [
          this.flightArrivalMoment.toDate(),
          this.flightDepartureMoment.toDate(),
        ]
        console.log("Setting dates from booked flight", dates)
      }
      */

      this.setFormValues({
        location: loc,
        dates: dates,
      })
    } else {
      //preset form values for non-meeting search

      this.initGooglePlaces().then(() => {

        if (this.$route.query.key) {
          let savedSearch = this.recentSearches.find(
            (search) => search.key === this.$route.query.key
          )

          if (savedSearch) {
            //clone the saved search data
            let savedData = JSON.parse(JSON.stringify(savedSearch.formData))
            this.setFormValues({
              location: savedData.loc,
              dates: [savedData.checkinDate, savedData.checkoutDate],
            })
          }

          //set default form values from booked flight
        } else if (this.flightArrivalLeg?.arrivingAirport) {
          this.setFlightDefaults()
        } else if (this.searchLocation.name) {
          this.place = this.searchLocation.name
        }
      })
    }
    this.getAccountDetails(this.$globals.currentTravellerProfile.account.id);

  },
}
</script>

<style>
.search-form-grid {
  display: grid;
  grid-gap: 1rem;
  margin-bottom: 1.5rem;
}

@media screen and (min-width: 769px) {
  .search-form-grid {
    grid-template-columns: 2.5fr 1.5fr 1fr;
    align-items: flex-start;
    gap: 40px;
  }
}

.location-search-container {
  width: 100%;
}

.location-input-group {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  max-width: 600px;
}

.search-location-field {
  flex: 1;
  margin-bottom: 0.5rem;
}

.search-dates-field {
  margin-bottom: 0.5rem;
  min-width: 300px;
}

.search-button-container {
  margin-bottom: 0.5rem;
}

/* Saved addresses styles */
.saved-addresses-select {
  width: auto;
}

.saved-address-button {
  height: 2.75em;
  padding: 0 1rem;
  background-color: #e9ecef;
  border: 1px solid #dee2e6;
  color: #495057;
  border-radius: 4px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
}

.saved-address-button:hover:not(:disabled) {
  background-color: #dee2e6;
  border-color: #ced4da;
}

.saved-address-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.saved-address-button .icon {
  color: #6c757d;
}

.saved-addresses-select .dropdown-menu {
  width: 300px !important;
  min-width: 300px !important;
  max-width: 300px !important;
  margin-top: 0.25rem;
  right: 0;
  left: auto;
}

.saved-addresses-select .dropdown-content {
  width: 100%;
  padding: 0.5rem 0;
  max-width: 300px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.saved-addresses-select .dropdown-item {
  width: 100%;
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  white-space: normal;
  word-wrap: break-word;
  transition: background-color 0.2s ease;
}

.saved-addresses-select .dropdown-item:last-child {
  border-bottom: none;
}

.saved-addresses-select .dropdown-item:hover {
  background-color: #f8f9fa;
}

.saved-address-option {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
}

.saved-address-name {
  font-weight: 500;
  color: #363636;
  font-size: 0.9rem;
  white-space: normal;
  word-wrap: break-word;
}

.saved-address-details {
  font-size: 0.8rem;
  color: #6c757d;
  line-height: 1.2;
  white-space: normal;
  word-wrap: break-word;
}

/* Date picker styles */
.datepicker .datepicker-header {
  background-color: #f5f5f5;
  padding: 0.5rem;
}

.datepicker .datepicker-cell.is-selected {
  background-color: #3273dc;
  color: white;
}

.datepicker .datepicker-cell.is-today {
  border: 1px solid #3273dc;
}

.datepicker .dropdown-menu {
  min-width: 310px;
}

/* Google Places Autocomplete customization */
.pac-container {
  border-radius: 4px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
  border: 1px solid #dbdbdb;
  padding: 0;
  margin-top: 2px;
}

.pac-container:after {
  display: none;
}

.pac-container .pac-item {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
}

.pac-container .pac-item:last-child {
  border-bottom: none;
}

.pac-container .pac-item:hover {
  background-color: #f5f5f5;
}
</style>
